module.exports = __webpack_public_path__ + "media/images/clients/running_watches-b96eae90d5f40d5a707a0599a6458b51.svg";